import React, { useState, useEffect } from 'react';

import {
  BookOpen, Code, Cpu, Bot, Users, Mail, Phone, MapPin,
  ChevronDown, ArrowRight, Star, Award, Globe, Terminal,
  BookMarked, Lightbulb, Zap, UserCheck, PanelsTopLeft, BrainCircuit
} from 'lucide-react';

const styles = {
  colors: {
    primary: '#2563eb', // Royal blue - represents trust and professionalism
    secondary: '#7c3aed', // Purple - innovation and creativity
    accent: '#f59e0b', // Amber - energy and positivity
    text: {
      primary: '#1f2937', // Dark gray for main text
      secondary: '#4b5563', // Medium gray for secondary text
      light: '#9ca3af', // Light gray for tertiary text
    },
    background: {
      light: '#ffffff',
      subtle: '#f8fafc',
      gradient: 'linear-gradient(135deg, #2563eb 0%, #7c3aed 100%)',
    }
  },
  spacing: {
    section: 'py-24',
    container: 'max-w-7xl mx-auto px-4 sm:px-6 lg:px-8',
  }
};


export default function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Home', href: '/#home' },
    { name: 'Solutions', href: '/#solutions' },
    { name: 'Products', href: '/#products' },
    { name: 'Workshops', href: '/#workshops' },
    // { name: 'About', href: '#about' },
    { name: 'Contact', href: '/#contact' },
  ];

  return (
    <nav className={`fixed w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'
      }`}>
      <div className={styles.spacing.container}>
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center">
            {/* <span className="text-2xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
              CloudTales
            </span> */}
            <img src='/ctlogo.png' style={{ width: '81px' }} alt='Cloudtales Technologies' />
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                className={`${isScrolled ? 'text-grey-700' : 'text-black'
                  } hover:text-blue-600 font-medium transition-colors duration-300`}
              >
                {link.name}
              </a>
            ))}
            {/* <button className="bg-blue-600 text-white px-6 py-2 rounded-full hover:bg-blue-700 transition-colors duration-300">
              Get Started
            </button> */}
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden text-gray-700"
          >
            <ChevronDown
              className={`w-6 h-6 transition-transform duration-300 ${isMobileMenuOpen ? 'rotate-180' : ''
                }`}
            />
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <div className="md:hidden bg-white border-t">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                className="block px-4 py-3 text-gray-700 hover:bg-gray-50"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                {link.name}
              </a>
            ))}
          </div>
        )}
      </div>
    </nav>
  );
};